import React from "react";

// Safe initials extractor handling multi-space strings and empty inputs
const getInitials = (name = "") =>
  name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join("")
    .toUpperCase() || "NA";

const BeneficiaryAvatar = ({ name, size = 40, className = "" }) => (
  <div
    className={`flex shrink-0 items-center justify-center rounded-full bg-[#9ed492] text-text-primary font-semibold 
    leading-normal select-none transition-colors duration-200 dark:bg-[#508b49] ${className}`}
    style={{
      width: size,
      height: size,
      // fontSize: Math.max(12, Math.round(size * 0.38)), // Dynamically scales text size with avatar dimensions
    }}
    aria-hidden
  >
    {getInitials(name)}
  </div>
);

export default React.memo(BeneficiaryAvatar);